/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table, Tooltip } from "antd";
import Data from "../../assets/jsons/quotations";
import FeatherIcon from "feather-icons-react";
import {
  onShowSizeChange,
  itemRender,
} from "../../_components/paginationfunction";
import { filterIcon } from "../../_components/Imagepath";
import AddVendor from "../../customers/vendors/addVendor";
import { CURRENCY_SYMBOLS } from "./components/constant";

const Quotations = () => {
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const user = window.CURRENT_USER;
  const COMPANY = window?.COMPANY || {};
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchQuotations();
  }, []);

  const fetchQuotations = async () => {
    try {
      setLoading(true);
      const response = await fetch("/invoice/quotation-list/");

      if (!response.ok) {
        throw new Error("Failed to fetch quotations");
      }

      const data = await response.json();
      setQuotations(data);
    } catch (error) {
      console.error("Error fetching quotations:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const datasource = Data?.Data;
  console.log(datasource);
  const [deleteId, setDeleteId] = useState(null);

  // Handle delete action
  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      setLoading(true);
      const response = await fetch(
        `/invoice/quote-invoices-delete/${deleteId}/`,
        {
          method: "DELETE",
          headers: {
            "X-CSRFToken": document.cookie
              .split("; ")
              .find((row) => row.startsWith("csrftoken="))
              ?.split("=")[1],
          },
        }
      );
      if (!response.ok) throw new Error("Failed to delete quote");
      fetchQuotations();
    } catch (error) {
    } finally {
      setLoading(false);
      setDeleteId(null);
    }
  };
  const leadStage = [
    { value: "new", label: "New" },
    { value: "technical", label: "Technical" },
    { value: "false_inquiry", label: "False inquiry" },
    { value: "follow_up", label: "Follow up" },
  ];
  const columns = [
    {
      title: "Quotation ID",
      dataIndex: "quote_number",
      sorter: (a, b) => a.quote_number.localeCompare(b.quote_number),
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      render: (text, record) => (
        <div>
          <h2 className="table-avatar">{text}</h2>
        </div>
      ),
    },
    {
      title: "Quote Date",
      dataIndex: "quote_date",
      sorter: (a, b) => new Date(a.quote_date) - new Date(b.quote_date),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      sorter: (a, b) => a.subject.localeCompare(b.subject),
    },
    {
      title: "Total Amount",
      dataIndex: "total",
      render: (text, row) => {
        return (
          <span className="text">
            {CURRENCY_SYMBOLS[COMPANY.currency_type]} {text}
          </span>
        );
      },
      sorter: (a, b) => parseFloat(a.total) - parseFloat(b.total),
    },
    // {
    //   title: "Lead Stage",
    //   dataIndex: "lead_stage",
    //   render: (text, record) => (
    //     <div>
    //       <span className="badge bg-success">
    //         {leadStage.find((stage) => stage.value === text)?.label || "-"}
    //       </span>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Lead Source",
    //   dataIndex: "load_source",
    //   render: (text, record) => <div>{text || "-"}</div>,
    // },

    {
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => (
        <div>
          <div className="d-flex align-items-center">
            <Tooltip title="Download Quotation" placement="top">
              <a
                href={`/invoice/quotes/${record.id}/download`}
                className="btn-action-icon me-2"
                title="Download Quotation"
              >
                <FeatherIcon icon="download" />
              </a>
            </Tooltip>
            <Tooltip title="View Quotation" placement="top">
              <a
                href={`/invoice/quotes/${record.id}/download?debug=1`}
                className="btn-action-icon me-2"
                title="View Quotation"
              >
                <FeatherIcon icon="eye" />
              </a>
            </Tooltip>
            {user?.user_role !== "customer" && (
              <Tooltip title="Edit Quotation" placement="top">
                <Link
                  className="btn-action-icon"
                  to={`/invoice/${record.id}/edit-quotations`}
                >
                  <i className="far fa-edit" />
                </Link>
              </Tooltip>
            )}
            {user?.user_role !== "customer" && (
              <Tooltip title="Delete Quotation" placement="top">
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_modal"
                  onClick={() => setDeleteId(record.id)}
                >
                  <i
                    className="far fa-trash-alt me-2"
                    style={{ color: "red" }}
                  />
                </Link>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header">
                <h5>Quotations</h5>
                <div className="list-btn">
                  <ul className="filter-list">
                    {user?.user_role !== "customer" && (
                      <li>
                        <Link
                          className="btn btn-primary"
                          to="/invoice/add-quotations"
                        >
                          <i
                            className="fa fa-plus-circle me-2"
                            aria-hidden="true"
                          />
                          Create Quotations
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            {/* Search Filter */}
            <div id="filter_inputs" className="card filter-card">
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-sm-6 col-md-3">
                    <div className="input-block mb-3">
                      <label>Name</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-3">
                    <div className="input-block mb-3">
                      <label>Email</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-3">
                    <div className="input-block mb-3">
                      <label>Phone</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Search Filter */}
            {/* Table */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card-table">
                  <div className="card-body purchase">
                    <div className="table-responsive table-hover">
                      {loading ? (
                        <div className="text-center">Loading quotations...</div>
                      ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                      ) : (
                        <Table
                          pagination={{
                            total: quotations.length,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            onShowSizeChange: onShowSizeChange,
                          }}
                          columns={columns}
                          dataSource={quotations}
                          rowKey="id"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AddVendor setShow={setShow} show={show} />

        <div
          className="modal custom-modal fade"
          id="delete_modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-header">
                  <h3>Delete Quotation</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div className="modal-btn delete-action">
                  <div className="row">
                    <div className="col-6">
                      <button
                        type="button"
                        onClick={handleDelete}
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-primary paid-continue-btn"
                      >
                        Delete
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-primary paid-cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Quotations;
